















































































import Vue from 'vue';
import commonClient from '../../../../common/apis';
import { TaskType } from '../../../../common/models/TaskType';
import Task from '../../../../common/models/Task';
import customerVuex from '../../../../customer/vuex/common';
import format from '../../../../customer/components/filter/makeCustomerQuery';
import TaskItem from '../../../../common/components/TaskItem.vue';
import CustomerFilterDisplayBox from '../../../../mass/components/mpgroup/CustomerFilterDisplayBox.vue';
import customerClient from '../../../../customer/apis';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    TaskItem,
    CustomerFilterDisplayBox,
  },
  data() {
    return {
      exVisible: false,
      created: false,
      canCreate: true,
      groupLoaded: false,
      loaded: false,
      exFields: ['basic'],
      exLocalFields: [],
      tasks: [],
    };
  },
  methods: {
    confirmExFields() {
      this.exFields = this.exLocalFields;
      this.exVisible = false;
    },
    confirmCreate() {
      commonClient.createTask({
        input: {
          CustomerExport: {
            query: format.mkFilterQueries(this.customerFilter),
            exFields: this.exFields.splice(1, 10),
          },
        },
        taskType: TaskType.CustomerExport,
        expectCount: 0,
      }).success(r => {
        this.created = true;
        this.loadTasks();
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
        this.created = false;
      }).error((e) => {
        this.$Message.error(e.toString());
        this.created = false;
      });
    },
    loadTasks() {
      commonClient.getTasksByTypes({
        tpes: [TaskType.CustomerExport],
        page: 1,
        size: 1000,
      }).success(r => {
        this.tasks = r.tasks;
        this.canCreate = !r.tasks.some((a: Task) => a.status === 0 || a.status === 1);
        if (this.canCreate) {
          this.created = false;
        }
        this.loaded = true;
      });
    },
    loadExtraData() {
      customerClient.getGroups().success(r => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
        customerClient.getMemberCards().success(r => {
          this.$store.commit('SET_MEMBER_CARDS', r.levels);
          this.groupLoaded = true;
        });
      });
    },
  },
  mounted() {
    this.loadTasks();
    setInterval(() => {
      this.loadTasks();
    }, 5000);
    this.loadExtraData();
  },
});
